'use client'

import { memo, type ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { CRAFT_MEDIA } from './craft-media'

type CraftSectionProps = {
  id?: string
  'data-section'?: string
  alt?: boolean
  className?: string
  children: ReactNode
}

/** baby: Soft kraft section shell: no boxed HUD panels. */
export const CraftSection = memo(function CraftSection({
  id,
  'data-section': dataSection,
  alt = false,
  className,
  children,
}: CraftSectionProps) {
  return (
    <section
      id={id}
      data-section={dataSection ?? id}
      className={cn('craft-block', alt && 'craft-block--alt', className)}
    >
      <div className="craft-block__inner">{children}</div>
    </section>
  )
})

CraftSection.displayName = 'CraftSection'

type CraftDividerProps = {
  /** baby: Cycle sticker motifs so dividers don’t feel identical. */
  motif?: 'plane' | 'star' | 'tape'
}

/** baby: Torn kraft strip + craft sticker. Product Hunt divider language. */
export const CraftDivider = memo(function CraftDivider({ motif = 'plane' }: CraftDividerProps) {
  const sticker =
    motif === 'star'
      ? CRAFT_MEDIA.stickers.star
      : motif === 'tape'
        ? CRAFT_MEDIA.stickers.tape
        : CRAFT_MEDIA.dividerOrnament

  return (
    <div className="craft-divider" aria-hidden>
      <div className="craft-divider__tear" />
      <img className="craft-divider__mark" src={sticker} alt="" />
      <div className="craft-divider__tear craft-divider__tear--flip" />
    </div>
  )
})

CraftDivider.displayName = 'CraftDivider'
